import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { resolveLegacyFlightPath } from "@/lib/legacy-flight-redirects";

// Catch-all: każdy nieistniejący URL zwraca 404.
// Wcześniej robiliśmy 301 → "/", ale Google klasyfikował to jako
// "Strona z przekierowaniem" / "Duplikat, Google wybrał inny URL kanoniczny"
// i nie indeksował realnych stron. Stare URL-e (np. /do-tajlandii, /warszawa)
// to orphan landingi z poprzedniej wersji serwisu — dla SEO lepsze
// jest twarde 404 niż masowe soft-404 do home.
export const Route = createFileRoute("/$")({
  head: () => ({ meta: [
    { title: "Nie znaleziono strony — Tanie Latanie" },
    { name: "description", content: "Ta strona nie istnieje. Wróć do Tanie Latanie, aby porównać loty i zaplanować podróż." },
    { name: "robots", content: "noindex,follow" },
    { property: "og:title", content: "Nie znaleziono strony — Tanie Latanie" },
    { property: "og:description", content: "Ta strona nie istnieje. Wróć do Tanie Latanie, aby porównać loty i zaplanować podróż." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
  ] }),
  loader: ({ params }) => {
    const target = resolveLegacyFlightPath(`/${params._splat ?? ""}`);
    if (target) throw redirect({ href: target, statusCode: 301 });
    throw notFound();
  },
  component: () => null,
});
